export const SectionBg = ({ src, position = "center", opacity = 0.35, testId }) => (
  <div aria-hidden="true" data-testid={testId} className="pointer-events-none absolute inset-0 overflow-hidden">
    <img src={src} alt="" loading="lazy" className="h-full w-full object-cover" style={{ objectPosition: position, opacity }} />
    <div className="absolute inset-0 bg-gradient-to-b from-[#071a15]/90 via-[#071a15]/35 to-[#071a15]" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#071a15]/85 via-[#071a15]/30 to-[#071a15]/55" />
  </div>
);
